import request from "@/utils/request";

export function customRecordingGetHeaders(params) {
    return request({
        url: "/api/services/app/CustomRecording/GetHeaders",
        method: "get",
        params: params
    });
}

export function customRecordingExportData(data) {
    return request({
        url: "/api/services/app/CustomRecording/ExportData",
        method: "post",
        data: data
    });
}

export function customRecordingCreate(data) {
    return request({
        url: "/api/services/app/CustomRecording/Create",
        method: "post",
        data
    });
}

export function customRecordingCreatePublicly(data) {
    return request({
        url: "/api/services/app/CustomRecording/CreatePublicly",
        method: "post",
        data
    });
}

export function customRecordingGet(params) {
    return request({
        url: "/api/services/app/CustomRecording/Get",
        method: "get",
        params
    });
}

export function customRecordingGetAllFormatted(data) {
    return request({
        url: "/api/services/app/CustomRecording/GetAllFormatted",
        method: "post",
        data,
        timeout: 1000 * 180,
    });
}

export function customRecordingGetChangeHistory(params) {
    return request({
        url: "/api/services/app/CustomRecording/GetChangeHistory",
        method: "get",
        params
    });
}

export function getLastSyncRecording(params) {
    return request({
        url: "/api/services/app/CustomRecording/GetLastSyncRecording",
        method: "get",
        params
    });
}

export function customRecordingGetLastExport(params) {
    return request({
        url: "/api/services/app/CustomRecording/GetLastExport",
        method: "get",
        params
    });
}

export function customRecordingGetPastWeekChart(params) {
    return request({
        url: "/api/services/app/CustomRecording/GetCustomRecordingPastWeekChart",
        method: "get",
        params
    });
}

export function customRecordingGetPastMonthChart(params) {
    return request({
        url: "/api/services/app/CustomRecording/GetCustomRecordingPastMonthChart",
        method: "get",
        params
    });
}

export function customRecordingGetPastYearChart(params) {
    return request({
        url: "/api/services/app/CustomRecording/GetCustomRecordingPastYearChart",
        method: "get",
        params
    });
}

export function customRecordingUpdate(data) {
    return request({
        url: "/api/services/app/CustomRecording/Update",
        method: "put",
        data
    });
}

export function customRecordingDelete(params) {
    return request({
        url: "/api/services/app/CustomRecording/Delete",
        method: "delete",
        params
    });
}

export function customRecordingDeleteMany(data) {
    return request({
        url: "/api/services/app/CustomRecording/DeleteMany",
        method: "post",
        data
    });
}

export function customRecordingEditManyByCustomField(data) {
    return request({
        url: "/api/services/app/CustomRecording/EditManyByCustomField",
        method: "PUT",
        data
    });
}

export function customRecordingGetImportFilePath(params) {
    return request({
        url: "/api/services/app/CustomRecording/GetImportFilePath",
        method: "get",
        params
    });
}

export function customRecordingImport(data) {
    return request({
        url: "/api/services/app/CustomRecording/Import",
        method: "post",
        data
    });
}

export function customRecordingGetAllAnalytics(data) {
    return request({
        url: "/api/services/app/CustomRecording/GetAllAnalytics",
        method: "post",
        data
    });
}

export function customRecordingUploadFile(data) {
    return request({
        url: "/api/services/app/CustomRecording/UploadFile",
        method: "post",
        data
    });
}

export function customRecordingUploadFilePublicly(data) {
    return request({
        url: "/api/services/app/CustomRecording/UploadFilePublicly",
        method: "post",
        data
    });
}

export function customRecordingUpdatePublic(data) {
    return request({
        url: "/api/services/app/CustomRecording/UpdatePublic",
        method: "put",
        data
    });
}

export function customRecordingGetPublic(params) {
    return request({
        url: "/api/services/app/CustomRecording/GetPublic",
        method: "get",
        params
    });
}

export function customRecordingUpdatePublicly(data) {
    return request({
        url: "/api/services/app/CustomRecording/UpdatePublicly",
        method: "put",
        data
    });
}

export function customRecordingCreatePublicCustomFields(data) {
    return request({
        url: "/api/services/app/CustomRecording/CreatePublicCustomFields",
        method: "post",
        data
    });
}

export function customRecordingGeneratePdfFromHtml(data) {
    return request({
        url: "/api/services/app/CustomRecording/GeneratePdfFromHtml",
        method: "post",
        data
    });
}

export function customRecordingSendPdfFromHtml(data) {
    return request({
        url: "/api/services/app/CustomRecording/SendPdfFromHtml",
        method: "post",
        data
    });
}

export function customRecordingGetForPrint(params) {
    return request({
        url: "/api/services/app/CustomRecording/GetForPrint",
        method: "get",
        params
    });
}

export function customRecordingGetCalendarView(params) {
    return request({
        url: "/api/services/app/CustomRecording/GetCalendarView",
        method: "get",
        params
    });
}


// WEBPACK FOOTER //
// ./src/api/custom_recording.js